import './Form.scss';

function Form() {
  return (

    <div className="form__container">
      <form className="form">
        <p>Deja tus datos y accede a nuestras ofertas:</p>
        <label htmlFor="name">Nombre:</label>
        <input type="text" name="name" placeholder="johndoe@gmail.com"></input>
        <label htmlFor="lastname">Apellidos:</label>
        <input type="text" name="lastname" placeholder="John"></input>
        <label htmlFor="email">Email:</label>
        <input type="email" name="email" placeholder="Doe"></input>
      </form>
    </div>

  );
}

export default Form;
